import axios from 'axios';
import { api, headers } from '../../app/conf';

/**
 * El usuario de la sesión actual, con sus permisos completos.
 *
 * La cookie solo puede llevar un subconjunto mínimo de permisos --el objeto
 * entero pasa el límite de ~4KB por cookie y el navegador la descarta en
 * silencio, ver auth/helpers/authoritiesCookie.js--, así que el resto se
 * hidrata desde acá.
 *
 * El token va por parámetro y no del store: el store se sincroniza desde la
 * cookie al montar, y esta llamada corre justamente en ese momento.
 */
export const getLoggedUserService = (accessToken) =>
  axios({
    method: 'get',
    url: `${api}/v2/users/me`,
    headers: { 'x-access-token': accessToken },
  });

/**
 * El usuario con la forma que usa esta app.
 *
 * `/v2/users/me` devuelve otra estructura --{ information, authorities }, con
 * `information.profile` singular y sin `username` ni `agentCode`--, mientras
 * que el CRM guarda el usuario que devuelve `POST /access`: 40 campos, planos.
 * Adaptar una en la otra sería fabricar un usuario recortado y confiar en que
 * nadie toque los que faltan, así que se pide el de verdad.
 *
 * El id es `information.id` de /me, que es el `_id` del CRM. Ojo con el nombre:
 * `information.crmUserId` es OTRO id --coincide con el campo `crmUserId` del
 * usuario, no con su `_id`--.
 */
export const getUserByIdService = (accessToken, id) =>
  axios({
    method: 'get',
    url: `${api}/v1/users/${id}`,
    headers: {
      ...headers,
      'X-Access-Token': accessToken,
    },
  });
